import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruef-antwort-aktualisieren';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefAntwortAktualisierenEffects {

    PruefAntwortAktualisieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEF_ANTWORT_AKTUALISIEREN),
        mergeMap((x: ac.PostPruefAntwortAktualisierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefAntwortAktualisieren(x.pruefAntwortModelRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefAntwortAktualisierenErfolgreichAction(result, x.pruefAntwortModelRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefAntwortAktualisierenFehlerAction(error, x.pruefAntwortModelRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
